var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":!_vm.hadData,"opacity":0}},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":5,"value":50,"rotate":100,"color":"light-blue","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }